<div #description [hidden]="markingSystemLabelModeEnabled" class="selectedCellsDescription" data-testid="labeleditor-cells-description">
  <div *ngIf="isTableProviderEmpty">{{'labelEditorPopup.label.table_provider_empty' | translate}}</div>
  <ng-container *ngIf="!isTableProviderEmpty">
    <div *ngIf="!isDirectPrintingTab">{{selectedCellsDescriptionMaterial}}</div>
    <div>{{selectedCellsDescriptionPosition}}</div>
  </ng-container>
</div>
<div id="{{'labelEditorTable_' + tableProvider.id}}" class="labelEditorTable" [style.height.px]="height - description.clientHeight"></div>
